<template>
  <v-content class="purchase">
    <div class="pa-3" v-if="data">
      <v-expansion-panels v-model="panel[0]" :disabled="disabled" v-for="(items, index) in data" :key="index" class="">
        <v-expansion-panel class="">
          <!-- <v-expansion-panel-header class="selecthead px-4">
              {{index}}
              <template v-slot:actions><v-icon color="#9D9D9D">mdi-chevron-down</v-icon></template>
            </v-expansion-panel-header> -->
          <div class="selectwrap">
            <v-expansion-panel-content v-for="(item, index) in items" :key="index" class="">
              <v-card class="mx-auto py-0 pl-0"
                @click="routerBindTo({ name: 'purchase-external-ldx-detail', query: { transaction_number: item.TransactionNumber} })">
                <v-row class="flex-nowrap" no-gutters align="center">
                  <v-col cols="11" class="pl-3">
                    <p class="mb-2 bold">{{ item.ShopName }}</p>
                    <p class="overline">ご購入日：{{ getDateFormat(item.TransactionDate) }}</p>
                    <p class="overline">レシートNo：{{ item.ReferenceSlipNo }}</p>
                    <p :class="{ 'red--text': item.AmountTotalInTax < 0 }" class="mb-2 bold text-right">
                      {{ Number(item.AmountTotalInTax).toLocaleString() }}円(税込)</p>
                    <p :class="{ 'red--text': item.Point < 0 }" class="overline mb-2 text-right">
                      (ポイント付与：{{ item.Point }}P)</p>
                  </v-col>
                  <v-col cols="1" class="pa-0">
                    <v-icon x-small right class="maincolor">fas fa-chevron-right</v-icon>
                  </v-col>
                </v-row>
              </v-card>
            </v-expansion-panel-content>
          </div>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>
    <infinite-loading ref="infiniteLoading" spinner="spiral" v-else-if="data === null">
      <div slot="spinner"><v-progress-circular :size="30" :width="2" class="maincolor"
          indeterminate></v-progress-circular></div>
      <div slot="no-more"></div>
      <div slot="no-results">購入履歴はありません。</div>
    </infinite-loading>
    <v-overlay :value="loading">
      <v-progress-circular :size="80" :width="2" class="maincolor" indeterminate></v-progress-circular>
    </v-overlay>

  </v-content>
</template>

<script>
import InfiniteLoading from 'vue-infinite-loading'
import moment from "moment"
export default {
  components: {
    InfiniteLoading,
  },
  data: () => ({
    init: [],
    data: [],
    panel: [0],
    loading: false,
    disabled: false,
    isLoadMore: true,
    startNo: 1,
    endNo:5
  }),
  async created() {
    this.init = this.storageGet('*')
    this.loading = true
    try {
      // 外部購買履歴(リスト)取得API
      let req = {
        params: {
          'shop_id': this.init.sid,
          'user_id': this.init.user_id,
          'start_no': this.startNo,
          'end_no': this.endNo
        }
      }

      let res = await this.apiCall('/purchase-external/ldx-list', req);
      if (!res) {
        this.loading = false
        return false;
      }
      this.$set(this, 'data', res.items);
      var totalFirst = 0;
      for (const value in this.data) {
        totalFirst = this.data[value].length;
      }
      if(totalFirst < 5) {
        this.isLoadMore = false;
      }
      this.$set(this, 'startNo', Number(res.startNo) + 5);
      this.$set(this, 'endNo', Number(res.endNo) + 5);
      if (this.data === null) {
        setTimeout(() => {
          this.$refs.infiniteLoading.stateChanger.complete()
        }, 10);
      } else {
        let initPanel = 0;
        Object.keys(this.data).forEach(function (key) {
          this[key] = initPanel
          initPanel = 1
        }, this.panel);
      }
      this.loading = false
    } catch (e) {
      this.loading = false
      this.callDialog('接続エラー', '一時的なエラーです。ネットワークの状態が不安定です。再度お試しください', 3);
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  updated(){
    const windowHeight = window.innerHeight;
    const purchaseElement = document.getElementsByClassName('purchase')[0];
    if (purchaseElement) {
      const contentHeight = purchaseElement.getBoundingClientRect().height;

      if (windowHeight >= contentHeight) {
        document.getElementsByClassName('purchase')[0].style.marginBottom = (windowHeight - contentHeight + 100) + 'px'; 
      }
    }
  },
  methods: {
    getDateFormat: function (item) {
      return moment(item).format('YYYY年M月D日')
    },
    handleScroll() {
      const bodyHeight = document.body.clientHeight ;
      const windowHeight = window.innerHeight;
      const bottomPoint = bodyHeight - windowHeight;
      const currentPos = window.pageYOffset;
      if (bottomPoint <= currentPos + 10) {
        this.loadData();
      }
    },
    loadData() {
      if (this.isLoadMore) {
        this.isLoadMore = false;
        this.loading = true;
        let req = {
          params: {
            'shop_id': this.init.sid,
            'user_id': this.init.user_id,
            'start_no': this.startNo,
            'end_no': this.endNo
          }
        }
        let res = this.apiCall('/purchase-external/ldx-list', req);
        if (!res) {
          this.loading = false;
          this.isLoadMore = true;
          return false;
        }
        
        res.then(response => {
          var hasReponseHas = 0;
          if (response.items !== null && response.items !== undefined) {
            if (typeof response.items === 'object') {
              for (const key in response.items) {
                hasReponseHas = response.items[key].length;

                if (Object.prototype.hasOwnProperty.call(response.items, key) && Array.isArray(response.items[key])) {
                  if (this.data[key]) {
                    this.data[key].push(...response.items[key]);
                  } else {
                    this.data[key] = [...response.items[key]];
                  }
                }
              }
            }
            if(hasReponseHas < 5) {
              this.isLoadMore = false; 
            } else {
              this.isLoadMore = true;
            }
            this.startNo = Number(response.startNo) + 5;
            this.endNo = Number(response.endNo) + 5;
          }
          
          this.loading = false;
        });

      }
    }
  },
}
</script>

<style scoped>
.v-expansion-panel--active>.v-expansion-panel-header {
  min-height: 48px !important;
  margin-bottom: 8px;
}

.v-expansion-panels {
  border-radius: 22px !important;
}

.v-expansion-panel-header:before {
  opacity: 0.1 !important;
  border-radius: 22px !important;
}

.v-application .overline {
  word-break: break-all !important;
  line-height: 1rem;
  margin-bottom: 0px
}

.v-application .bold {
  font-weight: bold;
}

.v-item--active>>>.selectwrap {
  margin-bottom: 20px;
  border-radius: 22px;
  border: none;
  background: #fff;
  box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.2);
}

.v-expansion-panels:not(.v-expansion-panels--accordion):not(.v-expansion-panels--tile)>.v-expansion-panel--active+.v-expansion-panel,
.v-expansion-panels:not(.v-expansion-panels--accordion):not(.v-expansion-panels--tile)>.v-expansion-panel--next-active {
  border-radius: 22px;
}

.v-item--active::before {
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}

.v-expansion-panel-content>>>.v-expansion-panel-content__wrap {
  padding: 0 12px 0px 12px !important;
}

.v-expansion-panel-content:not(:last-child) {
  /* border-bottom: 1px solid rgba(0, 0, 0, 0.2); */
}

.v-card {
  -webkit-box-shadow: none;
  box-shadow: none;
  /* margin-top: 5px; */
}
.v-expansion-panel-content
{
  padding-bottom: 12px;
  padding-top: 12px;
}
.v-expansion-panel-content:nth-child(n + 2) {
  padding-top: 0;
}
.v-item--active .selectwrap {
  margin-bottom: 0;
}

.v-item-group {
  margin-bottom: 6px;
}</style>
